// extracted by mini-css-extract-plugin
module.exports = {"loginBlock":"Login_loginBlock__3b2Mg","rememberMe":"Login_rememberMe__1wbfB","captchaBlock":"Login_captchaBlock__SBrSN","btn":"Login_btn__3zokw","test":"Login_test___cWJD"};